import { StreamShapes } from "@sablier/v2-constants";
import { IConfiguration } from "../../system/setup";
import { IDynamicStepper, initial } from "./config";
import Form from "./form";
import { process } from "./process";
import { check, identify, precompute, simulate } from "./setup";
import summary from "./summary";

const extension: IConfiguration = {
  check,
  identify,
  process,
  Form,
  initial,
  shape: StreamShapes.dynamicStepper.id,
  summary,
  simulate,
  precompute,
};

export type { IDynamicStepper };
export { extension };
